<template>
  <div :style="'background-color:'+backgroundColor" class="menu-item" :class="itemClass">{{name}}</div>
</template>

<script>
export default {
  props: ["backgroundColor","itemClass","name"],
};
</script>

<style>
.menu-item {
    width: 100%;
    line-height: 50px;
    border-bottom: 1px solid #f2f2f2;
    cursor: pointer;
}
</style>